import { render, staticRenderFns } from "./ErrSttInputDialog.vue?vue&type=template&id=8a0203f0&scoped=true"
import script from "./ErrSttInputDialog.vue?vue&type=script&lang=ts"
export * from "./ErrSttInputDialog.vue?vue&type=script&lang=ts"
import style0 from "./ErrSttInputDialog.vue?vue&type=style&index=0&id=8a0203f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a0203f0",
  null
  
)

export default component.exports